import { Track } from './Track';
import { TrackWithEventError, getError } from './utils';
import {
	TrackEventPropsType,
	TrackAppClickPropsType,
	TrackApiSuccessPropsType,
	TrackApiErrorPropsType,
	TrackApiNoResponsePropsType,
} from './TrackingFunctions.d';

/**
 * RAT App Tracking
 *
 * @url https://confluence.rakuten-it.com/confluence/display/RMCCXP/%5BWB%5D+Web+blocks+metrics
 */

/* ** NOTE: Track RAT event ** */

export function TrackApiSuccess({ data, ...rest }: TrackApiSuccessPropsType) {
	return Track({
		screen: 'MESSAGE_API',
		action: 'SUCCESS',
		message: data,
		...rest,
	});
}

export function TrackApiError({
	ratAccountId = '',
	ratServiceType = '',
	isMobile = false,
	error = '',
}: TrackApiErrorPropsType) {
	return Track({
		screen: 'MESSAGE_API',
		action: 'ERROR',
		ratAccountId,
		ratServiceType,
		isMobile,
		message: getError(error),
	});
}

export function TrackApiNoResponse({
	ratAccountId = '',
	ratServiceType = '',
	isMobile = false,
}: TrackApiNoResponsePropsType) {
	return Track({
		screen: 'MESSAGE_API',
		action: 'NO_RESPONSE',
		ratAccountId,
		ratServiceType,
		isMobile,
	});
}

/* ** NOTE: Track RAT and log in case of error ** */

export async function TrackAppLoad(rest: {
	trackCb: () => Promise<unknown>;
	ratAccountId: string;
	ratServiceType: string;
	isMobile: boolean;
}) {
	return TrackWithEventError({
		screen: 'METRIC',
		action: 'LOAD',
		campaignId: '',
		contentId: '',
		...rest,
	});
}

export function TrackAppHit(rest: TrackEventPropsType) {
	return TrackWithEventError({
		screen: 'METRIC',
		action: 'HIT',
		...rest,
	});
}

export function TrackAppAppear(rest: TrackEventPropsType) {
	return TrackWithEventError({
		screen: 'METRIC',
		action: 'VIEW',
		...rest,
	});
}

export function TrackAppClick({ url = '', ...rest }: TrackAppClickPropsType) {
	return TrackWithEventError({
		screen: 'METRIC',
		action: 'CLICK',
		message: `Target URL: ${url}`,
		...rest,
	});
}
